import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource } from "kea-resource";
const controller = rpcController("ConsultarGuiaSucursalZE");

export const ConsultarGuiaSucursalZE = cacheResource({

    /**Obtiene todas las guías que encajen con los filtros */
    Query: async (filtro: models.FiltroGuiasSucursalZE): Promise<models.GuiaDTO[]> => await controller("Query", {}, filtro),
    QueryInicial :async (): Promise<models.GuiaDTO[]> => await controller("QueryInicial", {}, {}),
}, {
        Query: true,
        QueryInicial:true
    }, {

    });




// WEBPACK FOOTER //
// ./app/resources/items/consultaguiassucursalze.tsx